import { ff } from '@atlassian/jira-feature-flagging';
import type { StoreApi, QueryGithubOnboardingRef } from './types';

export const actions = {
	setIsAutoOpened:
		(isAutoOpened: boolean) =>
		({ setState }: StoreApi) => {
			setState({ isAutoOpened });
		},
	setIsNbtToggleButtonVisible:
		(isNbtToggleButtonVisible: boolean) =>
		({ setState }: StoreApi) => {
			setState({ isNbtToggleButtonVisible });
		},
	setIsOnlyCurrentUserSelected:
		(isOnlyCurrentUserSelected: boolean) =>
		({ setState }: StoreApi) => {
			if (ff('jira.work-suggestions.remove-nbt-button') && !isOnlyCurrentUserSelected) {
				setState({ isOnlyCurrentUserSelected, isAutoOpened: false, isHiddenByUser: false });
			} else {
				setState({ isOnlyCurrentUserSelected });
			}
		},
	setShowBubbleNotification:
		(showBubble: boolean) =>
		({ setState }: StoreApi) => {
			setState({ showBubble });
		},
	setQueryGithubOnboardingRef:
		(queryGithubOnboardingRef: QueryGithubOnboardingRef) =>
		({ getState, setState }: StoreApi) => {
			if (getState().queryGithubOnboardingRef == null) {
				setState({ queryGithubOnboardingRef });
			}
		},

	onViewSettingsSpotlightStart:
		() =>
		({ setState }: StoreApi) => {
			setState({ activeViewSettingsSpotlight: 0 });
		},

	onViewSettingsSpotlightNext:
		() =>
		({ setState }: StoreApi) => {
			setState({
				activeViewSettingsSpotlight: 1,
			});
		},

	setOpenViewSettings:
		(openViewSettingsCallback: () => void) =>
		({ getState, setState }: StoreApi) => {
			if (!getState().openViewSettings) {
				setState({
					openViewSettings: openViewSettingsCallback,
				});
			}
		},
	setViewSettingsTogglePulses:
		(viewSettingsTogglePulses: boolean) =>
		({ setState }: StoreApi) => {
			setState({ viewSettingsTogglePulses });
		},
	setIsHiddenByUser:
		(isHiddenByUser: boolean) =>
		({ setState }: StoreApi) => {
			setState({
				isHiddenByUser,
			});
		},
} as const;

export type Actions = typeof actions;
